import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintManager_activate_deactivate_planService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { plan_id: string, is_active: boolean }): Promise<void> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.plan_id)) {
      missingRequiredInParams.push('\'plan_id\'');
    }
    if (isNil(inParams.is_active)) {
      missingRequiredInParams.push('\'is_active\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/functions/activate_deactivate_plan`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

